import { useStaticQuery, graphql } from "gatsby"

const usePostsQuery = () => {
  const {posts, categories, tags} = useStaticQuery(graphql`
    query PostsQuery {
      posts: allWpPost(sort: {date: DESC}) {
        nodes {
          ...ArticleCard
        }
      }
      categories: allWpCategory {
        nodes {
          name
          slug
        }
      }
      tags: allWpTag {
        nodes {
          name
          slug
        }
      }
    }
  `)
  return { posts: [...posts.nodes], categories: [...categories.nodes], tags: [...tags.nodes]} || {}
}

export default usePostsQuery